import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'react-form';

import InputBase from 'forms/InputBase';
import InputBlock from 'forms/InputBlock';

class CheckboxInput extends InputBase {

  render() {
    return (
      <InputBlock size={this.props.size} className={`input-checkboxBlock -checkbox ${this.blockClassNames()}`}>
        <label className="input-label -checkbox">
          <Checkbox field={this.props.name} className={this.inputClassName("input-checkbox")} />
          {this.props.label}
          {this.props.labelSecondary ?
            <span className="input-labelSecondary">{this.props.labelSecondary}</span>
            : null
          }
        </label>
        {this.props.children}
        {this.renderErrors()}
      </InputBlock>
    )
  }

}

CheckboxInput.propTypes = {
  name:     PropTypes.string.isRequired,
  label:    PropTypes.string.isRequired,
  labelSecondary: PropTypes.string,
  size:     PropTypes.string,
  children: PropTypes.element,
  errors:   PropTypes.object,
  formApi:  PropTypes.object,
  className: PropTypes.string,
};

export default CheckboxInput;
